import React, { useEffect, useState, useContext } from "react";
import { Button, Row, Col, Radio, Tag, Progress } from "antd"; // Progress import kela
import { SaveOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  Paper,
  TextField,
  Box,
  Typography,
  Divider,
  Button as MUIButton,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { URL as BASE_URL } from "../config";
import { LoaderContext } from "../Components/dashboard";

const themeColor = "#4B0082";

export default function SongMasterForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [mode, setMode] = useState(id ? "edit" : "create");
  const { setLoading } = useContext(LoaderContext);

  const [songName, setSongName] = useState("");
  const [mainTypes, setMainTypes] = useState([]);
  const [selectedMainType, setSelectedMainType] = useState(null);

  const [saving, setSaving] = useState(false);
  const [subTypes, setSubTypes] = useState([]);
  const [selectedSubType, setSelectedSubType] = useState(null);

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [videoStatus, setVideoStatus] = useState(0);
  const [songUrl, setSongUrl] = useState("");
  const [songDescription, setSongDescription] = useState("");
  const [isActive, setIsActive] = useState(1);

  const [removeImage, setRemoveImage] = useState(0);
  const [removeVideoFlag, setRemoveVideoFlag] = useState(0);

  const [photoFile, setPhotoFile] = useState(null);
  const [preview, setPreview] = useState("");

  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState("");

  // NEW STATE: Upload Progress track karnyasathi
  const [uploadProgress, setUploadProgress] = useState(0);

  const fkMainTypeId = selectedMainType?.mainTypeId || null;
  const fkSubTypeId = selectedSubType?.subTypeId || null;
  const fkCategoryId = selectedCategory?.categoryId || null;

   useEffect(() => {
    fetchMainTypes();
  }, []);

   const fetchMainTypes = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/songmaintype`);
      const activeMainTypes = res.data.data.filter((i) => i.isActive === 1);
      setMainTypes(activeMainTypes);
      return activeMainTypes; // Data return करा
    } catch {
      toast.error("Failed to load main types");
      return [];
    }
  };

  useEffect(() => {
    let isMounted = true;
    const startTime = Date.now();
    setLoading(true);

    const init = async () => {
      try {
        // Step 1: पहिले Main Types लोड करा
        const types = await fetchMainTypes();

        // Step 2: जर Edit Mode असेल तर Details लोड करा आणि 'types' List पास करा
        if (id) {
          await fetchDetails(types); // येथे आपण Fresh List पास करत आहोत
        }
      } catch (err) {
        console.log(err);
      } finally {
        // Loading Logic
        const elapsed = Date.now() - startTime;
        const remaining = 1500 - elapsed;
        setTimeout(() => {
          if (isMounted) setLoading(false);
        }, remaining > 0 ? remaining : 0);
      }
    };

    init();

    return () => {
      isMounted = false;
    };
  }, [id]);

 

  const fetchSubTypesByMainType = async (mainTypeId) => {
    try {
      const res = await axios.get(`${BASE_URL}/songsubtype`);
      const filtered = res.data.data.filter(
        (s) => s.fkMainTypeId === mainTypeId && s.isActive === 1
      );
      setSubTypes(filtered);
      setSelectedSubType(null);
      return filtered;
    } catch {
      setSubTypes([]);
      return [];
    }
  };

  const fetchCategoriesBySubType = async (subTypeId) => {
    try {
      const res = await axios.get(`${BASE_URL}/songcategory`);
      const filtered = res.data.data.filter(
        (c) => c.fkSubTypeId === subTypeId && c.isActive === 1
      );
      return filtered;
    } catch {
      return [];
    }
  };

  const fetchCategoriesByMainType = async (mainTypeId) => {
    try {
      const res = await axios.get(`${BASE_URL}/songcategory`);
      const filtered = res.data.data.filter(
        (c) => c.fkMainTypeId === mainTypeId && c.isActive === 1
      );
      return filtered;
    } catch {
      return [];
    }
  };

  const handleMainTypeChange = async (mainType) => {
    setSelectedMainType(mainType || null);
    setSelectedSubType(null);
    setSelectedCategory(null);
    setSubTypes([]);
    setCategories([]);

    if (!mainType) return;

    const fetchedSubTypes = await fetchSubTypesByMainType(mainType.mainTypeId);
    let allCategories = [];

    if (fetchedSubTypes.length > 0) {
      for (let st of fetchedSubTypes) {
        const cats = await fetchCategoriesBySubType(st.subTypeId);
        allCategories = [...allCategories, ...cats];
      }
    }

    if (fetchedSubTypes.length === 0) {
      allCategories = await fetchCategoriesByMainType(mainType.mainTypeId);
    }

    setCategories(allCategories);
  };

  const fetchDetails = async (mainTypesList = []) => {
    try {
      const res = await axios.get(`${BASE_URL}/songmaster/${id}`);
      const d = res.data.data;

      setSongName(d.songName || "");
      setSongDescription(d.songDescription || "");
      setIsActive(d.isActive ?? 1);

      const status = Number(d.videoStatus ?? 0);
      setVideoStatus(status);
      if (d.songPhoto) {
        setPreview(
          d.songPhoto.startsWith("http")
            ? d.songPhoto
            : `${BASE_URL}${d.songPhoto}`
        );
      } else {
        setPreview("");
      }

      if (status === 0) {
        if (d.video) {
          const fullVideoUrl = d.video.startsWith("http")
            ? d.video
            : `${BASE_URL}${d.video}`;

          setVideoPreview(fullVideoUrl);
        } else {
          setVideoPreview("");
        }

        setSongUrl("");
        setVideoFile(null);
      }

      if (status === 1) {
        setSongUrl(d.songUrl || "");

        setVideoPreview("");
        setVideoFile(null);
      }

      const mainTypeObj =
        mainTypesList.find((m) => m.mainTypeId === d.fkMainTypeId) || null;

      setSelectedMainType(mainTypeObj);

      if (mainTypeObj) {
        const fetchedSubTypes = await fetchSubTypesByMainType(
          mainTypeObj.mainTypeId
        );

        const selectedST =
          fetchedSubTypes.find((st) => st.subTypeId === d.fkSubTypeId) || null;

        setSelectedSubType(selectedST);

        let fetchedCategories = [];

        if (selectedST) {
          fetchedCategories = await fetchCategoriesBySubType(selectedST.subTypeId);
        } else {
          fetchedCategories = await fetchCategoriesByMainType(
            mainTypeObj.mainTypeId
          );
        }

        setCategories(fetchedCategories);

        const selectedCAT =
          fetchedCategories.find((c) => c.categoryId === d.fkCategoryId) || null;

        setSelectedCategory(selectedCAT);
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to load song details");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const removeFile = () => {
    setPhotoFile(null);
    setPreview("");
    setRemoveImage(1);
  };

   const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // VALIDATION: 500MB Limit check (500 * 1024 * 1024 bytes)
      const maxSize = 500 * 1024 * 1024;
      if (file.size > maxSize) {
        toast.error("File size exceeds 500MB limit!");
        e.target.value = ""; // Reset input
        return;
      }

      const videoURL = URL.createObjectURL(file);
      setVideoFile(file);
      setVideoPreview(videoURL);
      setSongUrl(""); // URL clear kara
      
      // Optional: Revoke memory to avoid leaks
      return () => URL.revokeObjectURL(videoURL);
    }
  };

  const removeVideo = () => {
    setVideoFile(null);
    setVideoPreview("");
    setRemoveVideoFlag(1);
  };

  const clearForm = () => {
    setSongName("");
    setSelectedMainType(null);
    setSelectedSubType(null);
    setSelectedCategory(null);
    setSubTypes([]);
    setCategories([]);
    setSongUrl("");
    setSongDescription("");
    setIsActive(1);

    setPhotoFile(null);
    setPreview("");

    setVideoFile(null);
    setVideoPreview("");

    setVideoStatus(0);

    setMode("create");
    setUploadProgress(0); // Clear progress on clear
  };

  const handleSave = async () => {
    if (saving) return;

    if (!songName.trim() || !fkMainTypeId) {
      toast.error("Song Name and Main Type required");
      return;
    }

    if (videoStatus === 0 && !videoFile && mode === "create") {
      toast.error("Please upload video (Self)");
      return;
    }

    if (videoStatus === 1 && songUrl.trim() === "") {
      toast.error("Please enter Song URL (Outside)");
      return;
    }

    try {
      setSaving(true);
      setUploadProgress(0); // Reset progress before starting

      const fd = new FormData();
      fd.append("songName", songName);
      fd.append("fkMainTypeId", fkMainTypeId);
      fd.append("fkSubTypeId", fkSubTypeId || "");
      fd.append("fkCategoryId", fkCategoryId || "");
      fd.append("songDescription", songDescription);
      fd.append("videoStatus", videoStatus);
      fd.append("isActive", isActive);

      if (photoFile) fd.append("songPhoto", photoFile);
      if (videoStatus === 0 && videoFile) fd.append("video", videoFile);
      if (videoStatus === 1 && songUrl.trim() !== "") fd.append("songUrl", songUrl);

      if (removeImage === 1) fd.append("removeImage", "1");
      if (removeVideoFlag === 1) fd.append("removeVideo", "1");

      // Config for Axios with Upload Progress
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        },
        // Timeout set kela (10 minutes)
        timeout: 6000000, 
      };

      if (mode === "edit" && id) {
        await axios.patch(`${BASE_URL}/songmaster/${id}`, fd, config);

        toast.success("Updated successfully");
        clearForm();
        return;
      }

      await axios.post(`${BASE_URL}/songmaster`, fd, config);

      toast.success("Created successfully");
      clearForm();
    } catch (err) {
      // Error handling
       if (err.code === 'ECONNABORTED') {
         toast.error("Upload timed out. Please check your connection.");
       } else {
         toast.error("Save failed");
       }
    } finally {
      setSaving(false);
      setUploadProgress(0);
    }
  };

  return (
    <Box sx={{ p: { xs: 0.1, md: 1 }, position: "relative" }}>
      {/* LOADING OVERLAY DESIGN */}
      {saving && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.85)",
            backdropFilter: "blur(4px)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            borderRadius: 3,
          }}
        >
          <Box
            sx={{
              background: "#fff",
              p: 4,
              borderRadius: 3,
              boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              textAlign: "center",
              minWidth: 300,
            }}
          >
            <Typography
              variant="h6"
              sx={{ mb: 2, color: themeColor, fontWeight: 700 }}
            >
              Uploading Data...
            </Typography>
            
            <Progress 
              percent={uploadProgress} 
              status="active" 
              strokeColor={{ from: '#4B0082', to: '#c488ee' }}
            />
            
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
              Please wait, do not close this window.
            </Typography>
          </Box>
        </Box>
      )}

      <Paper elevation={3} sx={{ p: { xs: 1, md: 3 }, borderRadius: 3 }}>
        {/* Header */}
        <Box display="flex" justifyContent="center" mb={2}>
          <Box
            sx={{
              background: `linear-gradient(90deg, ${themeColor}, #c488ee)`,
              px: { xs: 2.5, md: 4 },
              py: { xs: 0.8, md: 1.1 },
              borderRadius: "8px 22px 8px 22px",
              boxShadow: "0 6px 16px rgba(255,92,110,0.35)",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "18px" },
                fontWeight: 900,
                color: "#fff",
                letterSpacing: "0.7px",
                textTransform: "uppercase",
              }}
            >
              Song Master
            </Typography>
          </Box>
        </Box>

        <Divider
          sx={{
            mb: 3,
            background: `linear-gradient(90deg, transparent, ${themeColor}, transparent)`,
            height: "2px",
          }}
        />

        {/* Form Fields */}
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}>
              Song Name
            </Typography>
            <TextField
              size="small"
              fullWidth
              value={songName}
              onChange={(e) => setSongName(e.target.value)}
              disabled={saving} // Disable while saving
              sx={{
                "& .MuiOutlinedInput-root": { minHeight: 40, "& fieldset": { borderColor: "#ccc" }, "&:hover fieldset": { borderColor: "#aaa" }, "&.Mui-focused fieldset": { borderColor: "#aaa" } },
                "& .MuiInputBase-input": { fontSize: "13px", padding: "8.5px 12px", boxSizing: "border-box" },
              }}
            />
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}>
              Main Type
            </Typography>
            <Autocomplete
              options={mainTypes}
              getOptionLabel={(o) => o.mainTypeName || ""}
              value={selectedMainType}
              onChange={(_, v) => handleMainTypeChange(v)}
              disabled={saving} // Disable while saving
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Select main type"
                  sx={{
                    "& .MuiOutlinedInput-root": { minHeight: 40, "& fieldset": { borderColor: "#ccc" }, "&:hover fieldset": { borderColor: "#aaa" }, "&.Mui-focused fieldset": { borderColor: "#aaa" } },
                    "& .MuiInputBase-input": { fontSize: "13px", padding: "8.5px 12px" },
                  }}
                />
              )}
            />
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}>
              Sub Type
            </Typography>
            <Autocomplete
              options={subTypes}
              getOptionLabel={(o) => o.subTypeName || ""}
              value={selectedSubType}
              onChange={(_, v) => {
                setSelectedSubType(v || null);
                setSelectedCategory(null);
                if (v) fetchCategoriesBySubType(v.subTypeId).then((c) => setCategories(c));
              }}
              disabled={saving} // Disable while saving
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder={subTypes.length === 0 ? "No sub types available" : "Select sub type"}
                  sx={{
                    "& .MuiOutlinedInput-root": { minHeight: 40, "& fieldset": { borderColor: "#ccc" }, "&:hover fieldset": { borderColor: "#aaa" }, "&.Mui-focused fieldset": { borderColor: "#aaa" } },
                    "& .MuiInputBase-input": { fontSize: "13px", padding: "8.5px 12px" },
                  }}
                />
              )}
            />
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}>
              Category
            </Typography>
            <Autocomplete
              options={categories}
              getOptionLabel={(o) => o.categoryName || ""}
              value={selectedCategory}
              onChange={(_, v) => setSelectedCategory(v || null)}
              disabled={saving} // Disable while saving
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder={categories.length === 0 ? "No categories available" : "Select category"}
                  sx={{
                    "& .MuiOutlinedInput-root": { minHeight: 40, "& fieldset": { borderColor: "#ccc" }, "&:hover fieldset": { borderColor: "#aaa" }, "&.Mui-focused fieldset": { borderColor: "#aaa" } },
                    "& .MuiInputBase-input": { fontSize: "13px", padding: "8.5px 12px" },
                  }}
                />
              )}
            />
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={1} sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}>
              Status
            </Typography>
            <Radio.Group value={isActive} onChange={(e) => setIsActive(e.target.value)} disabled={saving}>
              <Radio value={1}>
                <Tag color="green">Active</Tag>
              </Radio>
              <Radio value={0}>
                <Tag color="red">Deactive</Tag>
              </Radio>
            </Radio.Group>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={1} sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}>
              Upload Photo
            </Typography>
            <Box display="flex" alignItems="center" gap={1.5}>
              <input hidden id="song-photo" type="file" accept="image/*" onChange={handleFileChange} disabled={saving} />
              <label htmlFor="song-photo">
                <MUIButton
                  variant="outlined"
                  component="span"
                  disabled={saving}
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "12px", md: "14px" },
                    borderColor: "#aaa",
                    color: "#8b8989",
                    "&:hover": { borderColor: themeColor, background: "rgba(255,92,110,0.08)" },
                  }}
                >
                  Upload Photo
                </MUIButton>
              </label>
              {preview && (
                <Box position="relative">
                  <img
                    src={preview}
                    alt="preview"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: 6,
                      objectFit: "cover",
                      border: `1px solid ${themeColor}`,
                    }}
                  />
                  <CloseIcon
                    onClick={() => !saving && removeFile()}
                    sx={{
                      position: "absolute",
                      top: -6,
                      right: -6,
                      cursor: saving ? "not-allowed" : "pointer",
                      background: "#fff",
                      borderRadius: "50%",
                      fontSize: 16,
                      color: themeColor,
                    }}
                  />
                </Box>
              )}
            </Box>
          </Col>

          <Col xs={24} sm={12} md={16}>
            <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}>
              Description
            </Typography>
            <TextField
              size="small"
              fullWidth
              multiline
              minRows={2}
              value={songDescription}
              onChange={(e) => setSongDescription(e.target.value)}
              disabled={saving}
              sx={{
                "& .MuiOutlinedInput-root": { minHeight: 40, "& fieldset": { borderColor: "#ccc" }, "&:hover fieldset": { borderColor: "#aaa" }, "&.Mui-focused fieldset": { borderColor: "#aaa" } },
                "& .MuiInputBase-input": { fontSize: "13px", padding: "8.5px 12px", boxSizing: "border-box" },
              }}
            />
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={1} sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}>
              Video Status
            </Typography>
            <Radio.Group
              value={videoStatus}
              onChange={(e) => {
                if (saving) return;
                const val = e.target.value;
                setVideoStatus(val);
                if (val === 0) {
                  setSongUrl("");
                } else {
                  setVideoFile(null);
                  setVideoPreview("");
                }
              }}
              disabled={saving}
            >
              <Radio value={0}>
                <Tag color="blue">Self</Tag>
              </Radio>
              <Radio value={1}>
                <Tag color="purple">Outside</Tag>
              </Radio>
            </Radio.Group>
          </Col>

          {videoStatus === 0 && (
            <Col xs={24} sm={12} md={8}>
              <Typography fontWeight={600} mb={1} sx={{ color: themeColor }}>
                Upload Video
              </Typography>
              <Box display="flex" alignItems="center" gap={1.5}>
                <input hidden id="song-video" type="file" accept="video/*" onChange={handleVideoChange} disabled={saving} />
                <label htmlFor="song-video">
                  <MUIButton
                    variant="outlined"
                    component="span"
                    disabled={saving}
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: "12px", md: "14px" },
                      borderColor: "#aaa",
                      color: "#8b8989",
                      "&:hover": { borderColor: themeColor, background: "rgba(255,92,110,0.08)" },
                    }}
                  >
                    Upload Video
                  </MUIButton>
                </label>
                {videoPreview && (
                  <Box position="relative">
                    <video
                      src={videoPreview}
                      width="80"
                      height="50"
                      controls
                      style={{
                        borderRadius: 6,
                        border: `1px solid ${themeColor}`,
                      }}
                    />
                    <CloseIcon
                      onClick={() => !saving && removeVideo()}
                      sx={{
                        position: "absolute",
                        top: -6,
                        right: -6,
                        cursor: saving ? "not-allowed" : "pointer",
                        background: "#fff",
                        borderRadius: "50%",
                        fontSize: 16,
                        color: themeColor,
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Col>
          )}

          {videoStatus === 1 && (
            <Col xs={24} sm={12} md={8}>
              <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}>
                Song URL
              </Typography>
              <TextField
                size="small"
                fullWidth
                value={songUrl}
                onChange={(e) => setSongUrl(e.target.value)}
                disabled={saving}
                sx={{
                  "& .MuiOutlinedInput-root": { minHeight: 40, "& fieldset": { borderColor: "#ccc" }, "&:hover fieldset": { borderColor: "#aaa" }, "&.Mui-focused fieldset": { borderColor: "#aaa" } },
                  "& .MuiInputBase-input": { fontSize: "13px", padding: "8.5px 12px", boxSizing: "border-box" },
                }}
              />
            </Col>
          )}
        </Row>

        <Box display="flex" justifyContent="end" mt={4} gap={1.5}>
          <Button
            icon={<SaveOutlined />}
            type="primary"
            onClick={handleSave}
            loading={saving}
            disabled={saving}
            style={{ background: themeColor, borderRadius: 25 }}
          >
            {mode === "edit" ? "Update" : "Save"}
          </Button>

          <Button
            icon={<InfoCircleOutlined />}
            onClick={() => navigate("/dashboard/songmasterlist")}
            disabled={saving}
            style={{
              borderRadius: 25,
              padding: "4px 20px",
              fontSize: 13,
              color: "red",
              borderColor: "red",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffe6e9";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
            }}
          >
            Details
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}